"use client";

import { extendVariants, Skeleton as BaseSkeleton } from "@heroui/react";

import { tailwindMergeConfig } from "@/utils/common/styleHelper/utils";

const Skeleton = extendVariants(
  BaseSkeleton,
  {
    variants: {
      background_color: {
        primary: {
          base: "bg-skeleton after:bg-skeleton dark:bg-skeleton dark:after:bg-skeleton",
          content: "opacity-100",
        },
      },
      rounded: {
        none: {
          base: "rounded-none",
        },
        sm: {
          base: "rounded-sm", // 2px
        },
        normal: {
          base: "rounded", // 4px
        },
        md: {
          base: "rounded-md", // 6px
        },
        lg: {
          base: "rounded-lg", // 8px
        },
        xl: {
          base: "rounded-xl", // 12px
        },
        "2xl": {
          base: "rounded-2xl", // 16px
        },
        "3xl": {
          base: "rounded-3xl", // 24px
        },
        full: {
          base: "rounded-full", // 9999px
        },
      },
      disableAnimation: {
        true: {
          base: "animate-none transition-none before:pointer-events-none",
          content: "",
        },
        false: {
          base: "animate-pulse-gother data-[loaded=true]:animate-none before:pointer-events-none",
          content: "",
        },
      },
    },
    defaultVariants: {
      background_color: "primary",
      rounded: "lg",
      disableAnimation: false,
    },
    compoundVariants: [{}],
  },
  {
    twMerge: true,
    twMergeConfig: tailwindMergeConfig,
  },
);

export default Skeleton;
